import React from 'react';
import PrivateRoute from './PrivateRoute';
import { Route, Switch, useParams } from 'react-router-dom';

import HomeIcon from '@material-ui/icons/Home';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import PersonPinCircleIcon from '@material-ui/icons/PersonPinCircle';

// Lazy load components
const AddEvent = React.lazy(() => import('../pages/AddEvent/AddEvent'));
const Home = React.lazy(() => import('../pages/Home'));
const Maps = React.lazy(() => import('../pages/Maps/Maps'));
const NoMatch = React.lazy(() => import('../common/components/NoMatch'));

export const routes = [
	{
		path: '',
		label: 'Domov',
		component: Home,
		icon: <HomeIcon />,
		isHome: true,
		auth: false,
		order: 1,
	},
	{
		path: 'prijava-smradu',
		label: 'Prijava smradu',
		component: AddEvent,
		icon: <AddCircleIcon />,
		isHome: false,
		auth: false,
		order: 2,
	},
	{
		path: 'lokacija',
		label: 'Moja lokacija',
		component: Maps,
		icon: <PersonPinCircleIcon />,
		isHome: false,
		auth: false,
		order: 3,
	},
].sort((a, b) => a.order - b.order);

export const join = (base, path) => `/${base}/${path}`;

export default function DomainRoutes() {
	const { url } = useParams();
	return (
		<Switch>
			{routes.map(({ path, component, auth }, i) => {
				if (auth) {
					const Component = component;
					return (
						<PrivateRoute exact key={i} path={join(url, path)}>
							<Component />
						</PrivateRoute>
					);
				}
				return (
					<Route exact key={i} path={join(url, path)} component={component} />
				);
			})}
			<Route path="*">
				<NoMatch />
			</Route>
		</Switch>
	);
}
